import { render, staticRenderFns } from "./projectRole.vue?vue&type=template&id=02bc8442&scoped=true"
import script from "./projectRole.vue?vue&type=script&lang=js"
export * from "./projectRole.vue?vue&type=script&lang=js"
import style0 from "./projectRole.vue?vue&type=style&index=0&id=02bc8442&prod&lang=scss&scoped=true"
import style1 from "../index.scss?vue&type=style&index=1&id=02bc8442&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bc8442",
  null
  
)

export default component.exports